export let InAppModalMessageType;

(function (InAppModalMessageType) {
  InAppModalMessageType["Splash"] = "Splash";
  InAppModalMessageType["Cover"] = "Cover";
  InAppModalMessageType["FullScreenSplash"] = "FullScreenSplash";
})(InAppModalMessageType || (InAppModalMessageType = {}));